import http from '../../../utils/fetch';
export default {
    query(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/viewInfoCredit/selectPage',
            method: 'post',
            params: q
        });
    },
    download(q) {
        return http({
            url: '/api/swyl/v1/infoCredit/viewInfoCredit/downloadExcel',
            method: 'post',
            params: q
        });
    },
    submitCheckContrastFile(q) {
        return http({
            url: '/api/swyl/v1/demo/userInfoCreditContrastSap/submitCheckContrastFile',
            method: 'post',
            params: q
        });
    },
    selectByInstidContrast(q) {
        return http({
            url: '/api/swyl/v1/demo/userInfoCreditContrastSap/selectByInstid?id='+q,
            method: 'post',
        });
    },
    shenPiCheckContrastFile(q) {
        return http({
            url: '/api/swyl/v1/demo/userInfoCreditContrastSap/shenPiCheckContrastFile',
            method: 'post',
            params: q
        });
    },
    printProductBook(c){
        return http({
            responseType: 'arraybuffer',
            url: '/api/swyl/v1/demo/userInfoCreditContrastSap/printContrastSap?id='+ c,
            method: 'post',
            //params: c
        });
    },
    selectContrastSapById() {
        return http({
            url: '/api/swyl/v1/demo/userInfoCreditContrastSap/selectContrastSapById',
            method: 'post',
        });
    },
}